/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2024 (original work) Open Assessment Technologies SA ;
 */

// values must be paths in app's locale folder
const localeFallbacks = {
    'ar': 'ar-arb',
    'ca': 'val-ES',
    'de': 'de-DE',
    'en': 'en-US',
    'es': 'es-ES',
    'fr': 'fr-FR',
    'nl': 'nl-NL',
    'pt': 'pt-BR',
    'val': 'es-ES',
};

/**
 * Get a fallback locale for a given locale
 * Useful for filling missing or partial locale dictionaries in i18n module
 * @example getLocaleFallback('es-MX') // => 'es-ES'
 *
 * @param {string} locale in BCP47 format
 * @returns {string} another locale
 */
export function getLocaleFallback(locale = 'en-US') {
    const localePrefix = locale.split('-')[0];
    return localeFallbacks[localePrefix] || 'en-US';
}
